import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/own-and-earn/earning-examples/page.tsx")